export interface IUserNotificationData {
    // Navigation IDs (primary)
    taskId?: string;
    companyId?: string;
    projectId?: string;

    // Display names (for message building in frontend)
    taskName?: string;
    companyName?: string;
    projectName?: string;

    // Actor information (who triggered the notification)
    triggeredByUserId?: string;
    triggeredByUserName?: string;

    // Type-specific fields
    role?: 'Clerk' | 'Manager'; // COMPANY_ASSIGNED
    dueDate?: Date; // DEADLINE_APPROACHING
    annotationId?: string;
    workflowArea?: string;

    // REV-21374 — NOTE_MENTION. `noteId` + `closingId` sind zusammen die Adresse des
    // Eintrags; ohne beide fuehrt der Klick nirgendwo hin.
    noteId?: string;
    closingId?: string;
    noteKind?: 'COMMENT' | 'TODO';
}
